import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { jcpGlobalLogout } from '../../actions/GlobalLogoutAction';

import './CustomEventPolyfill';

/* istanbul ignore next */
export default (store) => {
    /* to invoke this method we need
        document.dispatchEvent(new CustomEvent('jcp_global_logout'));
     */
    __SERVER__ ||
        document.addEventListener('jcp_global_logout', () => {
            store.dispatch(jcpGlobalLogout());
            TokenProvider.logout();
        });
};
